import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LucideTrendingUp, LucideUsers, LucideShoppingBag, LucideCheckCircle } from '@lucide/angular';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    LucideTrendingUp,
    LucideUsers,
    LucideShoppingBag,
  ],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent { }
